<template>
  <view flex="dir:left cross:center" :style="style">
    <el-radio-group v-model="chossenType">
      <el-radio-button value="daterange">按日</el-radio-button>
      <el-radio-button value="monthrange">按月</el-radio-button>
      <el-radio-button value="yearrange">按年</el-radio-button>
    </el-radio-group>
    <el-date-picker
      :disabled-date="disabledDateFun"
      @calendar-change="calendarChange"
      @change="rangeChange"
      v-model="chooseDays"
      :type="chossenType"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      popper-class="std-date-picker-popper"
      :format="chooseFormat"
      :shortcuts="shortcuts"
      style="margin-left: 11px"
    ></el-date-picker>
    <el-button style="margin-left: 11px" type="primary" @click="check">查询</el-button>
  </view>
</template>
<script lang="ts" setup>
import { ref } from "vue"
import { useDark, useToggle } from "@vueuse/core"
import { ElRadioButton, ElRadioGroup, ElDatePicker, ElButton } from "element-plus"
import { onMounted, computed } from "vue"
import moment from "moment"

const props = withDefaults(
  defineProps<{
    style?: { [key: string]: string }
    dateType?: 0 | 1 | 2
    range: {
      day: number
      month: number
      year: number
    }
    minDate?: string
    start?: string
    end?: string
    t?: undefined | "0" | "1"
  }>(),
  {
    style: () => ({}),
    dateType: () => 0,
    range: () => ({
      day: 93,
      month: 15,
      year: 3,
    }),
    minDate: () => "2022-01-01",
    start: () => "2022-01-01",
    end: () => "2022-01-01",
  },
)

const typeArray = ["daterange", "monthrange", "yearrange"]

const emits = defineEmits<{
  (e: "update:start", start: string): void
  (e: "update:end", end: string): void
  (e: "update:dateType", dateType: 0 | 1 | 2): void
}>()

const dateModel = ref("sevenDays")
const rangeFirst = ref("")

const minDate = moment(props.minDate)
const maxDate = moment().endOf("day")
if (props.t === "1") {
  maxDate.subtract(1, "days")
}

const chooseDays = ref<string[]>([props.start, props.end])
const chossenType = ref<"daterange" | "monthrange" | "yearrange">(typeArray[props.dateType] as "daterange" | "monthrange" | "yearrange")
const chooseFormat = computed(() => {
  switch (chossenType.value) {
    case "daterange":
      return "YYYY-MM-DD"
    case "monthrange":
      return "YYYY-MM"
    case "yearrange":
      return "YYYY"
    default:
      return "YYYY-MM-DD"
  }
})
const shortcuts = computed(() => {
  if (chossenType.value === "daterange") {
    const yeasterday = moment().endOf("day").subtract(1, "days")
    const weekStart = moment().startOf("week")
    const monthStart = moment().startOf("month")
    const range = [
      // 昨天
      {
        text: "昨天",
        value: () => {
          const startTime = moment().startOf("day").subtract(1, "days").toDate()
          const endTime = moment().endOf("day").subtract(1, "days").toDate()
          return [startTime, endTime]
        },
      },
    ]
    if (weekStart.isBefore(yeasterday)) {
      range.push({
        text: "本周",
        value: () => {
          const startTime = moment().startOf("week").toDate()
          let endTime = moment().endOf("week").toDate()
          if (props.t === "1") {
            endTime = moment().subtract(1, "days").endOf("day").toDate()
          } else if (props.t === "0") {
            endTime = moment().endOf("day").toDate()
          }
          return [startTime, endTime]
        },
      })
    }
    range.push({
      text: "上周",
      value: () => {
        const startTime = moment().startOf("week").subtract(1, "weeks").toDate()
        const endTime = moment().endOf("week").subtract(1, "weeks").toDate()
        return [startTime, endTime]
      },
    })
    if (monthStart.isBefore(yeasterday)) {
      range.push({
        text: "本月",
        value: () => {
          const startTime = moment().startOf("month").toDate()
          let endTime = moment().endOf("month").toDate()
          if (props.t === "1") {
            endTime = moment().subtract(1, "days").endOf("day").toDate()
          } else if (props.t === "0") {
            endTime = moment().endOf("day").toDate()
          }
          return [startTime, endTime]
        },
      })
    }
    range.push({
      text: "上月",
      value: () => {
        const startTime = moment().startOf("month").subtract(1, "months").toDate()
        const endTime = moment().endOf("month").subtract(1, "months").toDate()
        return [startTime, endTime]
      },
    })

    return range
  }
  return []
})
const disabledDateFun = (date: any) => {
  let disMinDate = minDate
  let disMaxDate = maxDate
  if (chossenType.value === "daterange") {
    if (rangeFirst.value) {
      const last93 = moment(rangeFirst.value).add(props.range.day, "days")
      const past93 = moment(rangeFirst.value).subtract(props.range.day, "days")
      if (disMaxDate.isAfter(last93)) {
        disMaxDate = last93
      }
      if (disMinDate.isBefore(past93)) {
        disMinDate = past93
      }
    }
  } else if (chossenType.value === "monthrange") {
    if (rangeFirst.value) {
      const last13 = moment(rangeFirst.value).add(props.range.month, "months").startOf("month")
      const past13 = moment(rangeFirst.value).subtract(props.range.month, "months").endOf("month")
      if (disMaxDate.isAfter(last13)) {
        disMaxDate = last13
      }
      if (disMinDate.isBefore(past13)) {
        disMinDate = past13
      }
    }
  } else if (chossenType.value === "yearrange") {
    if (rangeFirst.value) {
      const last3 = moment(rangeFirst.value).add(props.range.year, "years").startOf("years")
      const past3 = moment(rangeFirst.value).subtract(props.range.year, "years").endOf("years")
      if (disMaxDate.isAfter(last3)) {
        disMaxDate = last3
      }
      if (disMinDate.isBefore(past3)) {
        disMinDate = past3
      }
    }
  }
  return !moment(date).isBetween(disMinDate, disMaxDate)
}
const calendarChange = (dates: string) => {
  const [first] = dates
  rangeFirst.value = first
  dateModel.value = ""
}
const rangeChange = (dates: string) => {
  if (dates === null) {
    rangeFirst.value = ""
    chooseDays.value = []
    return
  }
  const [first, second] = dates
  // rangeFirst.value = first;
  chooseDays.value = [moment(first).format(chooseFormat.value), moment(second).format(chooseFormat.value)]
}
const check = () => {
  emits("update:start", moment(chooseDays.value[0]).format(chooseFormat.value))
  emits("update:end", moment(chooseDays.value[1]).format(chooseFormat.value))
  emits("update:dateType", typeArray.findIndex(item => item === chossenType.value) as 0 | 1 | 2)
}
onMounted(() => {
  const isDark = useDark()
  isDark.value = true
  useToggle(isDark)
})
</script>
